import { createMuiStyles } from '../../utils/mui';

export const applyScreenStyles = createMuiStyles({
  dialog: {
    minHeight: '80vh',
    m: 2,
    width: 'calc(100% - 2rem)',
  },
  centeredDialogContent: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  emptyEducationFailContent: {
    height: 1,
    px: 3,
    mt: 4,
  },
  programSelectCard: {
    display: 'flex',
    gap: '0.5rem',
    '& > div': {
      mt: 0,
    },
  },
  previewCard: {
    bgcolor: 'grey.50',
    borderRadius: 4,
    p: 3,
    mb: 3,
  },
  previewCardImg: {
    height: { xs: '3rem', lg: '6rem' },
    width: { xs: '3rem', lg: '6rem' },
    borderRadius: '50%',
    objectPosition: 'center',
  },
  discountBadge: {
    cursor: 'inherit',
    borderRadius: '0.25rem',
    '.MuiChip-label': {
      px: 1,
      fontWeight: 'Regular',
    },
  },
  previewAmountSection: {
    display: 'flex',
    justifyContent: 'space-between',
    flexDirection: {
      xs: 'row',
      sm: 'column',
    },
    gap: '0.75rem',
    alignItems: {
      xs: 'center',
      sm: 'flex-end',
    },
    '.MuiBox-root': {
      display: {
        sm: 'flex',
      },
      flexDirection: {
        sm: 'column',
      },
      alignItems: {
        sm: 'flex-end',
      },
    },
  },
});
